import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";

export const orSection = (theme: Theme) => css`
  text-align: center;
  text-transform: uppercase;
  color: ${theme.system.borderHover};
  position: relative;
  margin: 1rem 0;
  overflow: hidden;

  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    height: 1px;
    background-color: ${theme.system.borderHover};
    width: 40%;
  }

  &:before {
    left: 0;
  }

  &:after {
    right: 0;
  }
`;
